// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"FauxSelect__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FauxSelect/FauxSelect.scss
 ** module id = 917
 ** module chunks = 1
 **/